import { createSelector } from 'reselect';
import ownerGuidSelector from './ownerGuid';

const allConversationsSelector = state =>
  state.restricted.message.all_conversations;

export default createSelector(
  ownerGuidSelector,
  allConversationsSelector,
  (ownerGuid, allConversations) => allConversations[ownerGuid] || []
);



// WEBPACK FOOTER //
// ./src/selectors/openConversations.js